import React, { useEffect } from 'react';
import { Spinner } from '../../../../common';
import StudyProgramForm from './StudyProgramForm.jsx';
import { routes } from '../../../../../utils/helpers/ApiClient';
import { AppBarCMS } from '../../../../basic';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import {
  useGetStudyProgramQuery,
  useSaveStudyProgramMutation,
} from '../../../../../redux/services/study_programs';
import {
  useGetStudyProgramTypesQuery,
} from '../../../../../redux/services/study_program_types';
import { useGetTeachersQuery } from '../../../../../redux/services/users';
import { Form as AntdForm } from 'antd';
import { useToastMessages } from '../../../../../hooks/useToastMessages.jsx';

const StudyProgramsEdit = ({ mode }) => {
  const { id } = useParams();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [form] = AntdForm.useForm();

  const isCreate = mode === 'create';
  const isEdit = mode === 'edit';

  useEffect(() => {
    document.title = isEdit ? t('Editácia študijného programu') + ' - FRI CMS' : t('Pridanie študijného programu') + ' - FRI CMS';
  }, []);

  const {
    saveSuccess,
  } = useToastMessages();

  const { data: studyProgramTypes, isLoading: isLoadingTypes } = useGetStudyProgramTypesQuery();
  const { data: teachers, isLoading: isLoadingTeachers } = useGetTeachersQuery();

  const [
    saveStudyProgram,
    {
      isSuccess: isSaveSuccess
    },
  ] = useSaveStudyProgramMutation();

  const {
    data: studyProgramDetail,
    isLoading: isLoadingProgram,
  } = useGetStudyProgramQuery(id, { skip: !isEdit });

  useEffect(() => {
    if (isSaveSuccess) {
      saveSuccess();
      navigate(routes.cmsStudyPrograms);
    }
  }, [isSaveSuccess]);

  const studyProgramTitle =
    (isCreate && t('Pridanie študijného programu')) ||
    t('Editácia študijného programu');

  if ((isEdit && isLoadingProgram) || isLoadingTypes || isLoadingTeachers) {
    return <Spinner />;
  }

  const initials = {
    name: undefined,
    shortcut: undefined,
    study_program_type_id: undefined,
    guarantee: undefined,
    ws_code: undefined,
    active: true,
    publish: false,
    ...studyProgramDetail,
  };

  return (
    <>
      <AppBarCMS
        title={studyProgramTitle}
        backUrl={routes.cmsStudyPrograms}
        backUrlTooltip={t('Študijné programy')}
      />
      <div style={{ margin: '10px' }}>
        <StudyProgramForm
          form={form}
          studyProgramTypes={studyProgramTypes}
          teachers={teachers}
          initials={initials}
          isCreate={isCreate}
          onSubmit={(values) => {
            if (isCreate) {
              saveStudyProgram({ body: values });
            } else {
              saveStudyProgram({
                id: studyProgramDetail.id,
                body: values,
              });
            }
          }}
        />
      </div>
    </>
  );
};

export default StudyProgramsEdit;
